'use client';

import type { AutoFixProvider } from '@/lib/ai-review-settings/schema';
import type { FixType } from '@/lib/ai/coding-agent-service/fix-tracking';

import { trackClientEvent } from '@/lib/analytics/posthog-client';

export const FIX_BUTTON_SOURCE = {
  PR_V2_SINGLE_COMMENT: 'pr_v2_single_comment',
  PR_V2_FIX_ALL: 'pr_v2_fix_all',
  SCAN_SINGLE: 'scan_single',
  SCAN_BULK: 'scan_bulk',
} as const;

type FixButtonSource = (typeof FIX_BUTTON_SOURCE)[keyof typeof FIX_BUTTON_SOURCE];

type TrackFixButtonClickedArgs = {
  installationId: number | null | undefined;
  source: FixButtonSource;
  fixType: FixType;
  provider?: AutoFixProvider | null;
  owner?: string | null;
  repo?: string | null;
  pullNumber?: number | string | null;
  commentId?: number | string | null;
  filePath?: string | null;
  lineNumber?: number | null;
  fixReviewSessionId?: string | null;
  fixViolationCount?: number | null;
  violationId?: string | null;
  repoScanId?: string | null;
};

export function trackFixButtonClicked({
  installationId,
  source,
  fixType,
  provider,
  owner,
  repo,
  pullNumber,
  commentId,
  filePath,
  lineNumber,
  fixReviewSessionId,
  fixViolationCount,
  violationId,
  repoScanId,
}: TrackFixButtonClickedArgs) {
  const numericPullNumber =
    pullNumber == null ? null : typeof pullNumber === 'number' ? pullNumber : Number(pullNumber);

  trackClientEvent('fix_button_clicked', installationId?.toString(), {
    source,
    fixType,
    ...(provider ? { provider } : {}),
    ...(owner && repo ? { repositoryName: `${owner}/${repo}` } : {}),
    ...(numericPullNumber != null
      ? { pullNumber: Number.isFinite(numericPullNumber) ? numericPullNumber : pullNumber }
      : {}),
    ...(commentId != null ? { commentId: String(commentId) } : {}),
    ...(filePath ? { filePath } : {}),
    ...(typeof lineNumber === 'number' ? { lineNumber } : {}),
    ...(fixReviewSessionId ? { fixReviewSessionId } : {}),
    ...(typeof fixViolationCount === 'number' ? { fixViolationCount } : {}),
    ...(violationId ? { violationId } : {}),
    ...(repoScanId ? { repoScanId } : {}),
  });
}
